import React from "react";

import classNames from "classnames";
import { useTranslation } from "react-i18next";

import Pill from "../../common/Pill";
import styles from "./buy.module.scss";

interface Props {
  text?: string;
}

const BuyOperation = ({ text }: Props) => {
  const { t } = useTranslation();
  return (
    <Pill
      styleName="delivery"
      Lefticon={<img src="../../../assets/images/svg/buyIcon.svg" />}>
      <p className={classNames(styles.buyText, "p2")}>
        {text ? text : `${t("lbl_contract_details_buy")}`}
      </p>
    </Pill>
  );
};

export default BuyOperation;
